import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import secureStorage from '../services/secureStorage';

export const SHIFT_STARTED_KEY = 'shiftStarted';

interface ShiftManagementState {
  shiftStarted: boolean;
  shiftEnded: boolean;
  repairStarted: boolean;
  repairEnded: boolean;
  shiftStatusIndicator: string;
}

const initialState: ShiftManagementState = {
  shiftStarted: false,
  shiftEnded: false,
  repairStarted: false,
  repairEnded: false,
  shiftStatusIndicator: '',
};

const shiftManagementSlice = createSlice({
  name: 'shiftManagement',
  initialState,
  reducers: {
    setShiftStarted(state, action: PayloadAction<boolean>) {
      state.shiftStarted = action.payload;
      // Persist to secureStorage (encrypted IndexedDB) so tab reloads restore shift state
      secureStorage.setItem(SHIFT_STARTED_KEY, String(action.payload)).catch(() => {});
    },
    setShiftEnded(state, action: PayloadAction<boolean>) {
      state.shiftEnded = action.payload;
    },
    setRepairStarted(state, action: PayloadAction<boolean>) {
      state.repairStarted = action.payload;
    },
    setRepairEnded(state, action: PayloadAction<boolean>) {
      state.repairEnded = action.payload;
    },
    setShiftStatusIndicator(state, action: PayloadAction<string>) {
      state.shiftStatusIndicator = action.payload;
    },
  },
});

export const { setShiftStarted, setShiftEnded, setRepairStarted, setRepairEnded, setShiftStatusIndicator } = shiftManagementSlice.actions;
export default shiftManagementSlice.reducer;
